// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1ThFS","author":"Table_author__2gmUT","authorImage":"Table_authorImage__3b-70","unreadRow":"Table_unreadRow__22C4C"};